import React, { useEffect, useState, useRef  } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';

import imageCompression from 'browser-image-compression';
import { Link } from 'react-router-dom';

import ImageWithLoader from './components/ImageWithLoader';


function PrintTreeOrder() {
  
  const { navigate, isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();
  const { menu, toggleMobileMenu } = useAppLayout();
  const chartContainerRef = useRef(null);
  const chartInstanceRef = useRef(null);

  const queryClient = useQueryClient();

 
  const [backgroundModalOpen, setBackgroundModalOpen] = useState(false);

  const [selectedColor, setSelectedColor] = useState("");
 

  // Fetch background colors
  const { data: backgroundColor = [], isLoadingBc, isErrorBc } = useQuery({
    queryKey: ["backgroundColor"],
    queryFn: () =>
      axios
        .get(`${API_URL}/tree-background-color-api`, { withCredentials: true })
        .then((res) => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });



  const { data: familyNameData, isLoading, isError, refetch } = useQuery({
    queryKey: ['familyName'],
    queryFn: () =>
      axios.get(`${API_URL}/family-name-api`, { withCredentials: true })
        .then(res => res.data.family_name?.substring(0, 16) || ""),
    staleTime: 0,
    cacheTime: Infinity,
  });
  // local state for editing
const [header, setHeader] = useState("");

// keep header in sync when query loads
useEffect(() => {
  if (familyNameData) {
    setHeader(familyNameData);
  }
}, [familyNameData]);


   const { data: user, isLoadingP, isErrorP } = useQuery({
      queryKey: ['userDetails'],
      queryFn: () =>
        axios.get(`${API_URL}/user-details-api`, { withCredentials: true })
          .then(res => res.data),
      staleTime: 0,
      cacheTime: Infinity,
    });
  
    const [fullNames, setFullNames] = useState(
      `${user?.n_prefix || ""} ${user?.name || ""} ${user?.last_name || ""}`.trim()
    );
    const [phoneNumber, setPhoneNumber] = useState(user?.phone_number || "");
  
    const [email, setEmail] = useState(user?.email || "");
    
    useEffect(() => {
      if (user) {
        setFullNames(`${user.n_prefix || ""} ${user.name || ""} ${user.last_name || ""}`.trim());
        setPhoneNumber(user.phone_number || "");
        setEmail(user.email || "");
      }
    }, [user]);



  const { data: treeSize, isLoadingTs, isErrorTs } = useQuery({
    queryKey: ["treeSize"],
    queryFn: () =>
      axios
        .get(`${API_URL}/family-tree-size-api`, { withCredentials: true })
        .then((res) => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });

  const { data: pickupLocation, isLoadingLoc, isErrorLoc } = useQuery({
    queryKey: ["pickupLocation"],
    queryFn: () =>
      axios
        .get(`${API_URL}/pick-up-tree-location-api`, { withCredentials: true })
        .then((res) => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });

  


  //calculate
  const [selectedTree, setSelectedTree] = useState(null);
  const [copies, setCopies] = useState("1");
  const [selectedPickup, setSelectedPickup] = useState(null);

  // Calculate total
  /*const total =
  (Number(selectedTree?.amount) || 0) * copies +
  (Number(selectedPickup?.amount) || 0);*/

  const total =
  (Number(selectedTree?.amount) || 0) * (Number(copies) || 0) +
  (Number(selectedPickup?.amount) || 0);



 


  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    if (!familyNameData.trim()) {
      toast.error("Header is required");
      return false;
    }
  
    if (!fullNames.trim()) {
      toast.error("Full names are required");
      return false;
    }
  
    if (!phoneNumber.trim()) {
      toast.error("Phone number is required");
      return false;
    }

    if (!email.trim()) {
      toast.error("Email is required");
      return false;
    }
  
    
    const phoneRegex = /^(?:\+254|0)[17]\d{8}$/;
    if (!phoneRegex.test(phoneNumber)) {
      toast.error("Enter a valid phone number (e.g. 0712345678 or +254712345678)");
      return false;
    }
  
    if (!selectedTree) {
      toast.error("Please select a tree size");
      return false;
    }

    if (!selectedColor) {
      toast.error("Please select a tree background color");
      return false;
    }
  
    if (!selectedPickup) {
      toast.error("Please select a pickup location");
      return false;
    }
  
    return true;
  };

  const handleSaveOrder = async () => {

    if (!validateForm()) return;

    setLoading(true);
  
    const orderData = {
      header: header,
      tree_size: selectedTree?.id || null,
      number_of_copies: copies,
      background_color: selectedColor,
      full_names: fullNames.trim(),
      phone_number: phoneNumber.trim(),
      email: email.trim(),
      pickup_location: selectedPickup?.id || null,
      total_amount: total,
    };
  
    try {
      const response = await axios.post(
        `${API_URL}/save-tree-order-api`,
        orderData,
        { withCredentials: true }
      );
  
      toast.success(response.data.message || "Tree Order Placed", {
        position: "top-right",
        autoClose: 3000,
      });
      

      navigate('/print-tree-preview');

    } catch (error) {
      toast.error("Error saving details");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
 
  //check if order exist
  const [order, setOrder] = useState(null);
  const [loadingOrder, setLoadingOrder] = useState(true);
  
  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await axios.get(`${API_URL}/get-tree-order-api`, {
          withCredentials: true,
        });
        setOrder(response.data.order); // either object or null
      } catch (error) {
        console.error("Error fetching tree order:", error);
      } finally {
        setLoadingOrder(false);
      }
    };
  
    fetchOrder();
  }, []);
  //end check if order exist

  if (isLoading) return( 
    <div className="loadingspinnerDiv">
  <div className="loadingspinner"></div>
</div>
     );
  
  if (isError) return <p>Error loading data.</p>;



  return (
  <div className="scrollPageContainer theme-light">
    <div className="main-wrapper">
      {isSidebarVisible && <Sidebar />}
      <Header toggleSidebar={toggleSidebar} />
      <Sidebar show={showSidebar} toggle={toggleSidebar} />
      <Footerbar toggleSidebar={toggleSidebar} />
      <ToastContainer />

      <div className="page-wrapper">
        <div className="content container-fluid px-2 px-md-4">

          {/* Top Bar */}
          <div className="order-topbar">
            <Link to="/family-tree" className="order-back">
              <i className="fa fa-arrow-left" />
            </Link>

            <div className="order-titlewrap">
              <div className="order-title">Print Family Tree</div>
              
            </div>

            {!loadingOrder && order && (
              <Link to="/print-tree-preview" className="btn btn-outline-primary order-preview-btn">
                <i className="fa fa-eye me-2" />
                Preview Tree
              </Link>
            )}
          </div>

          {/* Info banner */}
          <div className="order-banner">
            <i className="fa fa-info-circle" />
            <div>
              <div className="banner-title">How it works</div>
              <div className="banner-text">
                Fill the details below. You’ll receive a notification (phone/email) to complete payment & confirm pickup.
              </div>
            </div>
          </div>

          <div className="row g-3 mt-2">
            {/* LEFT: FORM */}
            <div className="col-12 col-lg-8">
              <div className="card order-card">
                <div className="card-body p-3 p-md-4">

                  {/* Step 1 */}
                  <div className="order-step">
                    <div className="step-badge">1</div>
                    <div className="step-content">
                      <div className="step-title">Tree details</div>
                      <div className="step-sub">Choose header, size, copies and background color.</div>

                      <div className="row g-3 mt-1">
                        <div className="col-12 col-md-6">
                          <label className="form-label">Header</label>
                          <input
                            type="text"
                            name="header"
                            value={header}
                            onChange={(e) => setHeader(e.target.value)}
                            className="form-control"
                            placeholder="e.g. Kapkaon Family"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label className="form-label">Tree Size</label>
                          <select
                            name="tree_size"
                            className="form-select"
                            onChange={(e) =>
                              setSelectedTree(
                                treeSize.find((s) => s.id === parseInt(e.target.value)) ?? null
                              )
                            }
                          >
                            <option value="">-- Select Tree Size --</option>
                            {(treeSize || []).map((size) => (
                              <option key={size.id} value={size.id}>
                                {size.tree_size} (KES {size.amount})
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-12 col-md-6">
                          <label className="form-label">No. of Copies</label>
                          <input
                            type="number"
                            name="number_of_copies"
                            className="form-control"
                            min="1"
                            value={copies}
                            onChange={(e) => setCopies(e.target.value)}
                            onBlur={() => {
                              if (!copies || Number(copies) < 1) setCopies("1");
                            }}
                          />
                          <div className="form-hint">Minimum 1 copy</div>
                        </div>

                        <div className="col-12 col-md-6">
                          <label className="form-label d-flex align-items-center justify-content-between">
                            <span>Tree Background</span>

                            <button
                              type="button"
                              onClick={() => setBackgroundModalOpen(true)}
                              className="btn btn-outline-primary btn-sm"
                            >
                              Choose
                            </button>
                          </label>

                          <div className="color-preview-row">
                            <div
                              className="color-swatch"
                              style={{
                                backgroundColor: selectedColor || "#f3f4f6",
                                border: selectedColor ? "1px solid rgba(0,0,0,.08)" : "1px dashed #cbd5e1",
                              }}
                              title={selectedColor || "No color selected"}
                            />
                            <input
                              type="text"
                              className="form-control"
                              value={selectedColor || "No color selected"}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr className="order-divider" />

                  {/* Step 2 */}
                  <div className="order-step">
                    <div className="step-badge">2</div>
                    <div className="step-content">
                      <div className="step-title">Pickup details</div>
                      <div className="step-sub">
                        Make sure your phone number or email are updated to receive notifications.
                      </div>

                      <div className="order-warning">
                        <i className="fa fa-exclamation-triangle" />
                        <span>
                          Use a valid Kenyan number (e.g. <b>0712345678</b> or <b>+254712345678</b>)
                        </span>
                      </div>

                      <div className="row g-3 mt-1">
                        <div className="col-12 col-md-6">
                          <label className="form-label">Names</label>
                          <input
                            type="text"
                            name="full_names"
                            value={fullNames}
                            onChange={(e) => setFullNames(e.target.value)}
                            className="form-control"
                            placeholder="Names in full"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label className="form-label">Phone number</label>
                          <input
                            type="text"
                            name="phone_number"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            className="form-control"
                            placeholder="Enter phone number"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label className="form-label">Email</label>
                          <input
                            type="text"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control"
                            placeholder="Enter email"
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label className="form-label">Pickup Location</label>
                          <select
                            name="pickup_location"
                            className="form-select"
                            onChange={(e) =>
                              setSelectedPickup(
                                pickupLocation.find((s) => s.id === parseInt(e.target.value)) ?? null
                              )
                            }
                          >
                            <option value="">-- Select Location --</option>
                            {(pickupLocation || []).map((size) => (
                              <option key={size.id} value={size.id}>
                                {size.name} (KES {size.amount})
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Total + Buttons */}
                  <div className="order-footer-mobile d-lg-none mt-3">
                    <div className="order-total-box">
                      <div className="total-label">Total</div>
                      <div className="total-value">KES {total}</div>
                      <div className="total-breakdown">
                        {selectedTree ? (
                          <>
                            {selectedTree.tree_size} × {Number(copies) || 0}{" "}
                            <span className="muted">
                              + pickup {selectedPickup ? `KES ${selectedPickup.amount}` : "KES 0"}
                            </span>
                          </>
                        ) : (
                          <span className="muted">Select tree size to see breakdown</span>
                        )}
                      </div>
                    </div>

                    <button
                      onClick={handleSaveOrder}
                      className="btn btn-primary w-100 mt-2"
                      disabled={loading}
                    >
                      {loading ? "Updating..." : "Update Details"}
                    </button>
                    {!loadingOrder && order && (
    <Link to="/print-tree-preview" className="btn btn-outline-primary w-100 mt-2">
      <i className="fa fa-eye me-2" />
      Preview Tree
    </Link>
  )}

                  </div>

                </div>
              </div>
            </div>

            {/* RIGHT: SUMMARY */}
            <div className="col-12 col-lg-4 d-none d-lg-block">
              <div className="card order-summary sticky-top">
                <div className="card-body p-3 p-md-4">
                  <div className="summary-title">Order Summary</div>

                  <div className="summary-row">
                    <span className="muted">Header</span>
                    <span className="fw-semibold text-end">{header || "--"}</span>
                  </div>

                  <div className="summary-row">
                    <span className="muted">Tree Size</span>
                    <span className="fw-semibold text-end">
                      {selectedTree ? selectedTree.tree_size : "--"}
                    </span>
                  </div>

                  <div className="summary-row">
                    <span className="muted">Copies</span>
                    <span className="fw-semibold">{Number(copies) || 0}</span>
                  </div>

                  <div className="summary-row">
                    <span className="muted">Background</span>
                    <span className="d-flex align-items-center gap-2">
                      <span
                        className="mini-swatch"
                        style={{ backgroundColor: selectedColor || "#e5e7eb" }}
                      />
                      <span className="fw-semibold">{selectedColor || "--"}</span>
                    </span>
                  </div>

                  <div className="summary-row">
                    <span className="muted">Pickup</span>
                    <span className="fw-semibold text-end">
                      {selectedPickup ? selectedPickup.name : "--"}
                    </span>
                  </div>

                  <hr className="order-divider" />

                  <div className="summary-total">
                    <div className="muted">Total Amount</div>
                    <div className="summary-total-value">KES {total}</div>
                    <div className="summary-small muted">
                      (Tree + copies + pickup)
                    </div>
                  </div>

                  <button
                    onClick={handleSaveOrder}
                    className="btn btn-primary w-100 mt-3"
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update Details"}
                  </button>

                  {!loadingOrder && order && (
                    <Link to="/print-tree-preview" className="btn btn-outline-primary w-100 mt-2">
                      <i className="fa fa-eye me-2" />
                      Preview Tree
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Background modal (your original kept, only visuals improved slightly) */}
          <ReactModal
            isOpen={backgroundModalOpen}
            onRequestClose={() => setBackgroundModalOpen(false)}
            className="Modal"
            overlayClassName="Overlay"
          >
            <div className="modal-header">
              <h5 className="modal-title">Select Background Color</h5>
              <button
                type="button"
                className="btn-close modalCloseButton"
                onClick={() => setBackgroundModalOpen(false)}
              ></button>
            </div>

            <div className="modal-body">
              {isLoadingBc && <p>Loading colors...</p>}
              {isErrorBc && <p>Error loading colors.</p>}

              <div
                className="row"
                style={{
                  maxHeight: "320px",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {(backgroundColor || []).map((color, index) => (
                  <div
                    key={index}
                    className="col-6 col-md-4 mb-3 d-flex flex-column align-items-center"
                  >
                    <button
                      type="button"
                      className="color-tile"
                      onClick={() => {
                        setSelectedColor(color.color_code);
                        setBackgroundModalOpen(false);
                      }}
                      title={`Use ${color.color_name}`}
                      style={{ borderColor: selectedColor === color.color_code ? "#184A2C" : "rgba(0,0,0,.12)" }}
                    >
                      <span
                        className="color-tile-swatch"
                        style={{ backgroundColor: color.color_code }}
                      />
                      <span className="color-tile-name">{color.color_name}</span>
                      <span className="color-tile-code">{color.color_code}</span>
                      <span className="color-tile-action">Use</span>
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="modal-footer" />
          </ReactModal>

          <div className="row end-page-space"></div>
        </div>
      </div>

      <style>{`
        :root{
          --brand:#75B437;
          --brand-dark:#184A2C;
          --bg:#EBF4ED;
          --card:#ffffff;
          --border:#e5e7eb;
          --muted:#6b7280;
        }

        .order-topbar{
          display:flex;
          align-items:center;
          gap:12px;
          padding:12px 10px;
          background:#fff;
          border:1px solid var(--border);
          border-radius:16px;
          box-shadow:0 8px 18px rgba(0,0,0,.04);
          margin-top:10px;
        }
        .order-back{
          width:42px;
          height:42px;
          border-radius:12px;
          display:flex;
          align-items:center;
          justify-content:center;
          background:rgba(117,180,55,.10);
          color:var(--brand-dark);
          border:1px solid rgba(117,180,55,.25);
          text-decoration:none;
          flex-shrink:0;
        }
        .order-back i{ font-size:18px; }
        .order-titlewrap{ flex:1; min-width:0; }
        .order-title{
          font-weight:800;
          color:var(--brand-dark);
          font-size:1.05rem;
          line-height:1.2;
        }
        .order-subtitle{
          color:var(--muted);
          font-size:.9rem;
          margin-top:2px;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
        }
        .order-preview-btn{
          border-radius:12px;
          font-weight:700;
        }

        .order-banner{
          display:flex;
          gap:10px;
          align-items:flex-start;
          margin-top:12px;
          padding:14px 14px;
          background:linear-gradient(135deg, rgba(117,180,55,.12), rgba(24,74,44,.05));
          border:1px solid rgba(117,180,55,.22);
          border-radius:16px;
        }
        .order-banner i{
          color:var(--brand-dark);
          margin-top:2px;
          font-size:18px;
        }
        .banner-title{
          font-weight:800;
          color:var(--brand-dark);
          line-height:1.2;
        }
        .banner-text{
          color:#374151;
          font-size:.92rem;
          margin-top:2px;
        }

        .order-card{
          border:1px solid var(--border);
          border-radius:18px;
          box-shadow:0 10px 24px rgba(0,0,0,.05);
          overflow:hidden;
        }
        .order-divider{ opacity:.12; }

        .order-step{
          display:flex;
          gap:12px;
          align-items:flex-start;
        }
        .step-badge{
          width:34px;
          height:34px;
          border-radius:12px;
          display:flex;
          align-items:center;
          justify-content:center;
          color:#fff;
          font-weight:900;
          background:linear-gradient(135deg, var(--brand), var(--brand-dark));
          box-shadow:0 10px 20px rgba(24,74,44,.18);
          flex-shrink:0;
        }
        .step-title{
          font-weight:900;
          color:var(--brand-dark);
          font-size:1.02rem;
        }
        .step-sub{
          color:var(--muted);
          font-size:.9rem;
          margin-top:2px;
        }
        .form-label{
          font-weight:700;
          color:#111827;
        }
        .form-hint{
          color:var(--muted);
          font-size:.82rem;
          margin-top:6px;
        }

        .color-preview-row{
          display:flex;
          align-items:center;
          gap:10px;
        }
        .color-swatch{
          width:44px;
          height:44px;
          border-radius:12px;
          box-shadow:0 6px 16px rgba(0,0,0,.08);
          flex-shrink:0;
        }

        .order-warning{
          display:flex;
          gap:10px;
          align-items:center;
          padding:10px 12px;
          border-radius:14px;
          border:1px solid rgba(245, 158, 11, .25);
          background:rgba(245, 158, 11, .10);
          color:#7c2d12;
          margin-top:12px;
        }
        .order-warning i{ margin-top:1px; }

        .order-summary{
          border:1px solid var(--border);
          border-radius:18px;
          box-shadow:0 10px 24px rgba(0,0,0,.05);
          top:88px;
        }
        .summary-title{
          font-weight:900;
          color:var(--brand-dark);
          font-size:1.05rem;
          margin-bottom:8px;
        }
        .summary-row{
          display:flex;
          justify-content:space-between;
          gap:10px;
          padding:10px 0;
          border-bottom:1px dashed rgba(0,0,0,.08);
        }
        .summary-row:last-child{ border-bottom:none; }
        .muted{ color:var(--muted); }
        .mini-swatch{
          width:14px;
          height:14px;
          border-radius:6px;
          border:1px solid rgba(0,0,0,.12);
        }
        .summary-total{
          padding-top:6px;
          text-align:center;
        }
        .summary-total-value{
          font-size:1.6rem;
          font-weight:1000;
          color:#111827;
          letter-spacing:-.5px;
          margin-top:6px;
        }
        .summary-small{ font-size:.85rem; }

        .order-footer-mobile .order-total-box{
          border:1px solid rgba(0,0,0,.10);
          border-radius:16px;
          padding:12px 12px;
          background:#fff;
          box-shadow:0 10px 20px rgba(0,0,0,.05);
        }
        .total-label{ color:var(--muted); font-weight:700; }
        .total-value{ font-size:1.35rem; font-weight:1000; color:#111827; margin-top:2px; }
        .total-breakdown{ font-size:.85rem; color:#374151; margin-top:4px; }

        /* Buttons */
        .btn-primary{
          background:linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
          border:none;
          font-weight:800;
          border-radius:14px;
          box-shadow:0 10px 22px rgba(24,74,44,.20);
        }
        .btn-primary:hover{
          background:linear-gradient(135deg, var(--brand-dark) 0%, #0f3320 100%);
        }

        /* Color tiles in modal */
        .color-tile{
          width:100%;
          border-radius:16px;
          border:1px solid rgba(0,0,0,.12);
          background:#fff;
          padding:12px 10px;
          text-align:left;
          display:flex;
          flex-direction:column;
          gap:6px;
          transition:.18s ease;
          cursor:pointer;
        }
        .color-tile:hover{
          transform:translateY(-2px);
          box-shadow:0 14px 26px rgba(0,0,0,.08);
        }
        .color-tile-swatch{
          width:100%;
          height:44px;
          border-radius:12px;
          border:1px solid rgba(0,0,0,.12);
        }
        .color-tile-name{ font-weight:900; color:#111827; }
        .color-tile-code{ color:var(--muted); font-size:.85rem; }
        .color-tile-action{
          margin-top:4px;
          font-weight:900;
          color:var(--brand-dark);
          font-size:.9rem;
        }

        @media (max-width: 576px){
          .order-preview-btn{ display:none; }
          .order-subtitle{ white-space:normal; }
        }
      `}</style>
    </div>
  </div>
);

}

export default PrintTreeOrder;
